import styled from 'styled-components'

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${props => (props.dark ? '#231f20' : '#f9f9f9')};
  padding: 20px;
`
export const LoginForm = styled.form`
  background-color: ${props => (props.dark ? '#0f0f0f' : '#ffffff')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 30px;
  gap: 10px;
  width: 400px;
  box-shadow: 4px 4px 30px 5px ${props =>
    props.dark ? '#181818' : '#e2e8f0'} ;
`

export const Img = styled.img`
  width: 150px;
  margin: 30px 0px;
`

export const Label = styled.label`
  color: ${props => (props.dark ? 'white' : '#64748b')};
  font-weight: bold;
  font-size: 12px;
  align-self: flex-start;
  width: 120px;
`

export const Input = styled.input`
  border: 1px solid #94a3b8;
  background: transparent;
  border-radius: 4px;
  padding: ${props => (props.checkbox ? '0px' : '10px')};
  color: ${props => (props.dark ? '#1e293b' : '#1e293b')};
  margin-bottom: 10px;
  align-self: flex-start;
  outline: none;
  width: 100%;
`

export const FlexRow = styled.div`
  display: flex;
  align-self: flex-start;
  align-items: center;
  gap: 7px;
  margin: 5px 0px;
`

export const Button = styled.button`
  align-self: stretch;
  color: #ffffff;
  background-color: #3b82f6;
  font-size: 11px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
`

export const Error = styled.p`
  color: #ff0b37;
  font-size: 11px;
  align-self: flex-start;
  margin-top: 0px;
`

export const Checkbox = styled.input`
  margin: 0px;
  padding: 0px;
`

export const CheckboxLabel = styled.label`
  color: ${props => (props.dark ? 'white' : '#64748b')};
  font-weight: bold;
  font-size: 12px;
  align-self: flex-start;
  width: 120px;
`

// @media (max-width: 768px) {
//   .login-card {
//     width: 280px;
//     gap: 5px;
//     padding: 20px;
//   }
//   .login-img {
//     width: 80px;
//     margin: 0px 0px 10px 0px;
//   }
//   .label {
//     font-size: 10px;
//   }
//   .input {
//     padding: 7px;
//   }
//   .login-btn {
//     font-size: 10px;
//   }
// }
